* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.impact-info-wrapper {
  flex-direction: column;

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .impact-info {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }

  &.is-error {
    .impact-info {
      display: none;
    }
    .loading-error {
      display: block;
    }
  }
}
